"use client"

import { CalendarCheck, Settings, TrendingUp } from "lucide-react"

const pasos = [
  {
    icon: CalendarCheck,
    title: "Agenda tu demo",
    description: "30 min en vivo, adaptada a tu clínica.",
  },
  {
    icon: Settings,
    title: "Configuramos todo",
    description: "Usuarios, procedimientos y agenda listos en 24h.",
  },
  {
    icon: TrendingUp,
    title: "Empiezas a operar",
    description: "Tu equipo usa el sistema desde el día uno.",
  },
]

export function Projects() {
  return (
    <section id="como-funciona" className="py-16 lg:py-20 bg-[#fafafa] border-t border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <p className="text-center text-sm font-medium text-[#00676E] mb-8">
            Empieza en 3 pasos
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {pasos.map((paso, i) => {
              const Icon = paso.icon
              return (
                <div key={paso.title} className="flex flex-col items-center text-center">
                  <div className="flex items-center gap-3 mb-3">
                    <span
                      className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white"
                      style={{ backgroundColor: "#00676E" }}
                    >
                      {i + 1}
                    </span>
                    <div
                      className="w-10 h-10 rounded-xl flex items-center justify-center"
                      style={{ backgroundColor: "#e0f4f5", color: "#00676E" }}
                    >
                      <Icon className="h-5 w-5" />
                    </div>
                  </div>
                  <h3 className="font-semibold text-foreground mb-1">{paso.title}</h3>
                  <p className="text-sm text-muted-foreground">{paso.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
